/**
 * 日期格式化，yyyy-MM-dd
 */
export function dateFormat(date) {
    let format = 'yyyy-MM-dd';
    if (date !== 'Invalid Date') {
        var o = {
            "M+": date.getMonth() + 1, //month
            "d+": date.getDate(), //day
            "h+": date.getHours(), //hour
            "m+": date.getMinutes(), //minute
            "s+": date.getSeconds(), //second
            "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
            "S": date.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    }
    return '';
}

/**
 * 日期格式化，yyyy-MM-dd hh:mm:ss
 */
export function dateTimeFormat(date) {
    let format = 'yyyy-MM-dd hh:mm:ss';
    if (date !== 'Invalid Date') {
        var o = {
            "M+": date.getMonth() + 1, //month
            "d+": date.getDate(), //day
            "h+": date.getHours(), //hour
            "m+": date.getMinutes(), //minute
            "s+": date.getSeconds(), //second
            "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
            "S": date.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    }
    return '';
}

/*
 *@functionName: minuteToHMS
 *@params1: 分钟数转 hh:mm:ss
 *@return: 
 *@description:
 *@author: show
 *@date: 2021-01-18 11:32:48
 *@version: V1.0
*/
export function minuteToHMS(minute) {
    const num = Number(minute);
    const h = Number.parseInt(num / 60), m = Number.parseInt(num % 60), s = Number.parseInt((num % 60 - m) * 60);

    return `${h > 9 ? h : h > 0 ? '0' + h : '00'} : ${m > 9 ? m : m > 0 ? '0' + m : '00'} : ${s > 9 ? s : s > 0 ? '0' + s : '00'}`;
}

/*
 *@functionName: dayDisparity
 *@params1: startTiem
 *@params2: endTime
 *@return: 整数天数
 *@description: 计算两个时间点相隔的天数
 *@author: show
 *@date: 2021-01-18 15:29:21
 *@version: V1.0
*/
export function dayDisparity(startTiem, endTime) {
    return Number.parseInt(Math.abs(startTiem.getTime() - endTime.getTime()) / 1000 / 60 / 60 / 24) + 1;
}